import * as React from 'react';
import * as s from '../../components/PostCommentsHeader/components/Subscribe/SubscribeSkeleton.css';
import { Skeleton } from '../../components/Skeleton';

/**
 * Контейнер формы добавления/редактирования поста
 */
export const AddPostFormContainer = () => {
  return (
    <div className={s['wrapper']}>
      <div className={s['breadcrumbs']}>
        <Skeleton width={164} height={20} margin={'0 0 24px 0'} />
      </div>

      <div className={s['heading']}>
        <Skeleton width={320} height={32} margin={'0 0 32px 0'} />
      </div>

      <div className={s['title']}>
        <Skeleton width={200} height={16} margin={'0 0 8px 0'} />
        <Skeleton height={44} margin={'0 0 28px 0'} />
      </div>

      <div className={s['image']}>
        <Skeleton width={200} height={16} margin={'0 0 8px 0'} />
        <Skeleton height={116} margin={'0 0 28px 0'} />
      </div>

      <div className={s['body']}>
        <Skeleton width={200} height={16} margin={'0 0 8px 0'} />
        <Skeleton height={338} margin={'0 0 28px 0'} />
      </div>

      <div className={s['category']}>
        <Skeleton width={200} height={16} margin={'0 0 8px 0'} />
        <Skeleton height={44} margin={'0 0 28px 0'} />
      </div>
    </div>
  );
};
